export default __webpack_public_path__ + "static/media/logo-v1.b5fcfb55.png";